export const DEFAULT_DEPARTMENTS = [
  "Business Analyst",
  "Data Analyst",
  "Data Science",
  "Devops",
  "Full Stack Developer",
  "HR",
  "Management",
  "QA",
  "SAP ABAP Consultant",
  "SAP GRC Consultant",
  "UI / UX",
];
